import script from "./CommentListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentListItem.vue?vue&type=script&setup=true&lang=js"

import "./CommentListItem.vue?vue&type=style&index=0&id=93a48c32&lang=less"

const __exports__ = script;

export default __exports__